import { Alert, Button } from '@tempmee/react';

/** Shown in place of the reason select when the reasons (or the job) fail to load; mobile GOTU-15984's copy. */
export const ReasonsLoadError = () => (
  <Alert
    severity="error"
    description="We couldn't load the cancellation reasons."
    data-cy="cancellation-reasons-error"
  />
);

export interface IReasonsLoadErrorActionsProps {
  onRetry: () => void;
  onExit: () => void;
  isRetrying: boolean;
}

/** The way out and the retry for the error state; rendered in `DialogActions`. */
export const ReasonsLoadErrorActions = ({
  onRetry,
  onExit,
  isRetrying,
}: IReasonsLoadErrorActionsProps) => (
  <>
    <Button variant="outlined" size="small" data-cy="cancellation-reasons-exit" onClick={onExit}>
      Go to dashboard
    </Button>
    <Button
      size="small"
      loading={isRetrying}
      disabled={isRetrying}
      data-cy="cancellation-reasons-retry"
      onClick={onRetry}
    >
      Retry
    </Button>
  </>
);
